module.exports = __webpack_public_path__ + "img/DeletePopup.2ab9ec8f.png";